<template>
  <div v-if="sub_groups.length > 0" class="filters__body-section">
    <div class="heading-for-aside">Список подкатегорий</div>
    <router-link
      v-for="sub_group in sub_groups"
      :key="sub_group.id"
      :to="{ name: 'group', params: { group_slug: sub_group.slug } }"
      class="button-as-link button-as-link_solid filters__link"
    >
      <div class="button-as-link__label">{{ sub_group.name }}</div>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ByCategory",
  computed: {
    ...mapGetters({
      sub_groups: "group_info/GET_SUB_GROUPS",
    }),
  },
};
</script>

<style scoped></style>
